const content = {
  nav: {
    logo: 'Ali Chaabane',
    links: [
      // { text: 'Çalışmalar', to: 'project' },
      { text: 'İletişim', to: 'contact' },
    ],
  },

  header: {
    text: ['Merhaba!', "Ben Ali Chaabane.", 'Ben bir '],
    typical: [
      'Full Stack Yazılım Geliştiricisiyim 💻',
      2000,
      'Mobil & Web Geliştiricisiyim 📱',
      2000,
    ],
    btnText: 'Daha Fazla Keşfet',
  },

  stack: {
    title: 'Kullandığım Teknolojiler',
    tech: [
      { img: process.env.PUBLIC_URL + '/assets/flutter.png', alt: 'Flutter' },
      { img: process.env.PUBLIC_URL + '/assets/ionic.png', alt: 'Ionic' },
      { img: process.env.PUBLIC_URL + '/assets/angular.png', alt: 'Angular' },
      { img: process.env.PUBLIC_URL + '/assets/spring.png', alt: 'Spring Boot' },
      { img: process.env.PUBLIC_URL + '/assets/vue.png', alt: 'Vue.js' },
      { img: process.env.PUBLIC_URL + '/assets/nuxt.png', alt: 'Nuxt.js' },
      { img: process.env.PUBLIC_URL + '/assets/node.png', alt: 'Node.js' },
      { img: process.env.PUBLIC_URL + '/assets/express.png', alt: 'Express.js' },
    ],
    desc: `
Mobil ve web tabanlı çapraz platform uygulama geliştirme konusunda uzmanım.

Mobil uygulamalarda ağırlıklı olarak Flutter ve Ionic kullanarak Android ve iOS için
yüksek performanslı ve kaliteli uygulamalar geliştiriyorum.
Ayrıca Progressive Web App (PWA) çözümleri de üretiyorum.

Web ve backend tarafında ise çoğunlukla Angular ve Node.js (Express) ile çalışıyor,
aynı zamanda ölçeklenebilir ve sürdürülebilir backend servisleri geliştirmek için
Java Spring Boot kullanıyorum.

Temiz mimari, performans ve gerçek hayatta kullanılan üretim seviyesinde çözümler
üzerine odaklanıyor, modern araç ve framework’leri takip ederek kendimi sürekli geliştiriyorum.
    `,
  },

  languages: {
    title: 'Diller',
    list: [
      { name: 'Arapça', level: 'Ana Dil', percent: 100 },
      { name: 'İngilizce', level: 'İleri Seviye', percent: 90 },
      { name: 'Fransızca', level: 'İleri Seviye', percent: 80 },
      { name: 'İtalyanca', level: 'İş yerinde pratik kullanım', percent: 30 },
      { name: 'Türkçe', level: 'Orta Seviye', percent: 40 },
    ],
  },

  project: {
    visible: false,
    title: 'Projeler',
    img: process.env.PUBLIC_URL + '/assets/project-mobile.png',
    projectName: 'Meetup',
    desc: 'React ile geliştirdiğim ilk projelerimden biri olan Meetup uygulaması.',
    website: 'https://meetups-project-86e41.web.app/',
  },

  contact: {
    title: 'İletişime Geç',
    desc: `
Web ve çapraz platform mobil uygulama geliştirme alanında
5 yılı aşkın deneyime sahip bir Full Stack Yazılım Geliştiricisiyim.

Flutter, Ionic, Angular, Node.js ve Java Spring Boot konularında güçlü bir tecrübeye sahibim.
Uluslararası müşteriler için kurumsal ve e-ticaret odaklı,
üretim ortamında kullanılan projelerde aktif olarak görev aldım.

Ölçeklenebilir, temiz ve sürdürülebilir yazılım çözümleri üretmeyi seviyorum.
Agile çalışma ortamlarına hızlı uyum sağlar, ekip çalışmasına önem veririm.
    `,
    socials: [
      {
        alt: 'whatsapp',
        img: process.env.PUBLIC_URL + '/assets/whatsapp.png',
        link: 'https://api.whatsapp.com/send/?phone=905421959236',
      },
      {
        alt: 'email',
        img: process.env.PUBLIC_URL + '/assets/gmail.png',
        link: 'mailto:alichaabane.work@gmail.com',
      },
      {
        alt: 'linkedin',
        img: process.env.PUBLIC_URL + '/assets/link.png',
        link: 'https://www.linkedin.com/in/ali-chaabane/',
      },
      {
        alt: 'github',
        img: process.env.PUBLIC_URL + '/assets/github.png',
        link: 'https://github.com/alichaabane',
      },
    ],
    img: process.env.PUBLIC_URL + '/assets/my-image.jpg',
  },
};

export default content;
